<template>
    <HorizontalPills
      ref="horizontalPills"
      class="gmf-token-shop-color-selector"
      :items="colors"
      :showSocialButton="false"
      :selectedItem="modelValue"
      @update:selectedItem="v => $emit('update:modelValue', v)"
      role="radiogroup"
      aria-label="Color selector"
    >
      <template v-slot="{ item }">
        <ClickableColorPill :colors="item" :class="modelValue && item.uuid === modelValue.uuid ? 'gmf-active' : ''" 
        />
        <Icon v-if="unlockedColors.length > 0 && hasUnlockedColor(item)" icon="checkmark" class="gmf-color-pill-checkmark" aria-hidden="true" />
      </template>
    </HorizontalPills>
</template>
<style>
.gmf-context .gmf-token-shop-color-selector .gmf-horizontal-pills-item {
  padding: 0 !important;
  border-radius: 50%;
  border: unset;
}

.gmf-context .gmf-token-shop-color-selector .gmf-item-color-pill:not(.gmf-active) .gmf-color-pill {
  filter: drop-shadow(0px 0px 1px rgba(0,0,0,0.3));
}

.gmf-token-shop-color-selector .gmf-horizontal-pills-item.gmf-active {
  background-color: unset !important;
}

.gmf-token-shop-color-selector .gmf-color-pill-checkmark {
  position: absolute;
  height: 60%;
  width: 60%;
  left: 0;
  right: 3px;
  margin: 0 auto;
  --gmf-icon-color: var(--gmf-col-white);
  filter: drop-shadow(0px 0px 1px rgba(0,0,0,0.5));
}
</style>
<script>
import Icon from '@/components/Icon.vue';
import HorizontalPills from '../HorizontalPills.vue';
import ClickableColorPill from './ClickableColorPill.vue';

export default {
  components: {
    Icon,
    HorizontalPills,
    ClickableColorPill,
  },
  props: {
    colors: {
      Type: Array,
      default: () => [],
    },
    unlockedColors: {
      Type: Array,
      default: () => [],
    },
    modelValue: {
      Type: Object,
      default: () => null,
    },
  },
  methods: {
    hasUnlockedColor (color) {
      if (this.unlockedColors.find(c => c.uuid === color.uuid)) {
        return true;
      }
      return false;
    },
  },
};
</script>